<template>
	<div>
		<textarea :name="name"></textarea>
	</div>
</template>

<script>

	export default {

		$_veeValidate: {
			// fetch the current value from the innerValue defined in the component data.
			value() {
				return this.model;
			}
		},

		name: "summernote",

        data: function () {
            return {

            }
        },

        props: {
            model: {
                required: true,
            },

            name: {
                type: String,
                required: true,
            },

            height: {
                type: String,
                default: '150'
            }
        },

        mounted() {


            let config = {
							height: this.height,
							dialogsInBody: true,
                toolbar: [
                    ['style', ['bold', 'italic', 'underline', 'clear']],
                    ['font', ['strikethrough', 'superscript', 'subscript']],
                    ['fontsize', ['fontsize']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['height', ['height']],
									['link', ['link']]
									
                ]
            };

            let vm = this;

            config.callbacks = {

                onInit: function () {

                    $(vm.$el).summernote("code", vm.model);
                },

                onChange: function () {
                    vm.$emit('change', $(vm.$el).summernote('code'));
                },

                onBlur: function () {
                    vm.$emit('change', $(vm.$el).summernote('code'));
                }
            };

            $(this.$el).summernote(config);

        }

    }


</script>

<style>
	.tooltip {
		z-index: 9999999;
	}

  .note-editor.note-frame.card {
    width: 100%;
  }
</style>